import { useProjectContext } from "@hooks/context/useProjectContext";
import { Box, Tab, Tabs } from "@mui/material";
import * as RouteHelper from "@utils/routes";
import { Link, matchPath, useLocation } from "react-router-dom";

function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}
// interface AnalyticsPageTabsProps {}

export const AnalyticsPageTabs = (): JSX.Element => {
  const { selectedProject } = useProjectContext();

  const routeMatch = useRouteMatch([
    RouteHelper.analyticsLabourHours(":projectId"),
    RouteHelper.analyticsSpend(":projectId"),
  ]);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Box>
      <Tabs value={currentTab}>
        <Tab
          label="Labour Hours"
          value={RouteHelper.analyticsLabourHours(":projectId")}
          to={RouteHelper.analyticsLabourHours(selectedProject.id)}
          component={Link}
        />
        <Tab
          label="Social Procurement"
          value={RouteHelper.analyticsSpend(":projectId")}
          to={RouteHelper.analyticsSpend(selectedProject.id)}
          component={Link}
        />
      </Tabs>
    </Box>
  );
};
